import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsConfigService } from 'src/app/tabms/services/global/fields-config.service';
import { Observable, Subject, takeUntil, tap } from 'rxjs';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { DELETESUCCESS, EDITSUCCESS, OPERERROR, SAVESUCCESS } from 'src/app/tabms/tab-consts';
import { GridService } from '../../global/shared-grid/service/grid.service';
import { ParamsExtractorService } from 'src/app/tabms/services/global/params-extractor.service';
import { BaseAttachService } from 'src/app/tabms/services/base/base-attach.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { ActivatedRoute } from '@angular/router';
import { HttpEventType } from '@angular/common/http';
import { ImageHelperService } from 'src/app/tabms/services/global/image-helper.service';
import { FieldDictionaryListService } from 'src/app/tabms/services/global/field-dictionary-list.service';

@Component({
  selector: 'app-base-entry-footer',
  templateUrl: './base-entry-footer.component.html',
  styleUrl: './base-entry-footer.component.scss'
})
export class BaseEntryFooterComponent<T> {
  @Input() serviceInstance
  @Input() params
  @Input() headerKey
  @Input() headerParams: string[]
  @Input() branch = false
  headerId
  extraData: {} = {}
  headerParamsData
  // updateAllData: any[]=[]
  menuKey: string;
  pageParameter: string;
  systemMenuId: string
  currentFile
  previousSelectedFile
  imageId: string;
  imageKey: string;
  hasImage: boolean = false
  branchId: string

  private destroy$: Subject<void> = new Subject<void>();


  constructor(
    private baseService: BaseService,
    public fieldsConfigService: FieldsConfigService<T>,
    private gridService: GridService,
    private paramsExtractor: ParamsExtractorService,
    private baseAttachService: BaseAttachService,
    private sessionService: SessionWrapperService,
    private activatedRoute: ActivatedRoute,
    private imageHelper: ImageHelperService,
    private fieldDictionaryListService: FieldDictionaryListService
  ) {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.systemMenuId = params['id'];
      this.fieldDictionaryListService.getPageFields(this.systemMenuId);

    });
  }

  ngOnInit() {
    this.menuKey = this.sessionService.getMenuKey();
    this.pageParameter = this.sessionService.getPageParameter();

    this.baseService.transferItems.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          this.extraData = res
          this.headerId = this.extraData[this.headerKey]
          if (this.branch) this.branchId = this.extraData['branchid']
          this.getHeaderData(res);
          console.log('this.extraData', this.extraData, this.headerId);
        }
      }
    })// get other foreign keys

    this.gridService.saveRow.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res === null) return
        let savedRow = res;
        if (this.branch) savedRow = { ...savedRow, branchid: this.branchId }

        if (this.params) {
          const { paramsData, objectKeys } = this.paramsExtractor.getParamsData(res, this.params)

          if (paramsData) {
            const filteredObj = Object.fromEntries(
              Object.entries(savedRow).filter(([key]) => !objectKeys.includes(key))
            );

            savedRow = { ...filteredObj, ...paramsData }

          }
        }
        const savedData = { ...savedRow, ...this.extraData }
        if (!this.headerParamsData || Object.keys(this.headerParamsData).length === 0) {
          this.baseService.showErrorMessage('FormInValid');
          return;
        }
        if (res?.id) this.updateRow(savedData)
        else this.create(savedData)
      }
    })

    this.gridService.deleteRow.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) this.delete(res?.id);
      }
    }) //delete row

    this.baseService.addImage.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          this.hasImage = true
          this.currentFile = res?.id //image file
          this.imageKey = res?.formKey
        }
        else {
          this.currentFile = null
          this.hasImage = false
        }
      }
    })

  }


  //#region crud
  async create(data): Promise<void> {
    let formData = { ...data }

    if (this.hasImage) {
      // First upload the image for create operation
      await this.uploadImage('create');

      // Now add the uploaded image ID to the form data
      if (this.imageId) {
        //  delete formData['Logo'];
        formData[this.imageKey] = this.imageId;
      }
    }
    console.log('formData', formData);

    this.serviceInstance.create(formData).pipe(takeUntil(this.destroy$)).subscribe(
      async (res) => {
        // debugger
        let id = res?.result == null ? res.id : res.result.id;
        // console.log('id', id);
        this.baseService.showSuccessMessage(SAVESUCCESS);

        // this.gridService.getTableDataByHeaderId({ [this.headerKey]: this.headerId });
        if (this.branch) this.gridService.getTableDataByHeaderId({ [this.headerKey]: this.headerId, branchid: this.branchId });
        else if (this.headerParamsData) this.gridService.getTableDataByHeaderId(this.headerParamsData);
        // else this.gridService.getTableDataByHeaderId({ [this.headerKey]: this.headerId });

        this.serviceInstance.channel.postMessage('new-item-added');

      },
      (err) => {
        console.log('err', err);
        this.baseService.showErrorMessage(OPERERROR);
      }
    );
  }

  async updateRow(data): Promise<void> {
    // debugger
    let updatedData = { ...data };

    if (this.hasImage) {
      await this.uploadImage('update');
      if (this.imageId) {
        //  delete updatedData['Logo'];
        updatedData[this.imageKey] = this.imageId;
      }
    }
    this.update$(updatedData).pipe(takeUntil(this.destroy$)).subscribe();

  }

  update$(data): Observable<any> {
    console.log(data)
    return this.serviceInstance?.update(data.id, data).pipe(tap(() => {
      this.baseService.showSuccessMessage(EDITSUCCESS)
      this.gridService.update([]);
      this.serviceInstance.channel.postMessage('new-item-added');
    }));
  }

  //delete row
  delete(id: string): void {
    this.serviceInstance?.delete(id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.baseService.showSuccessMessage(DELETESUCCESS);
        // this.gridService.getTableDataByHeaderId({}); //refresh
        if (this.headerParamsData) this.gridService.getTableDataByHeaderId(this.headerParamsData);
        // else this.gridService.getTableDataByHeaderId({ [this.headerKey]: this.headerId });
      },
      error: (err) => {
        this.baseService.showErrorMessage(OPERERROR);
      }
    })
  }
  //#endregion

  //#region uploading Image
  isSameFile(file1: File, file2: File): boolean {
    if (!file1 || !file2) return false;
    if (file1.name === file2.name && file1.size === file2.size) {
      this.hasImage = false; // to avoid delay in update
      return true;
    }
    return false;
  }


  uploadImage(operation: 'create' | 'update' = 'create'): Promise<void> {
    return new Promise((resolve, reject) => {
      const file: File = this.currentFile;

      // For create operations, always upload the image (don't check previousSelectedFile)
      // For update operations, check if it's the same file to avoid unnecessary uploads
      if (!file) {
        resolve();
        return;
      }

      if (operation === 'update' && this.previousSelectedFile && this.isSameFile(file, this.previousSelectedFile)) {
        resolve();
        return;
      }

      const newFileName = 'image' + file.name.substring(file.name.lastIndexOf('.'));
      const renamedFile = new File([file], newFileName, { type: file.type });
      const fileName = file.name;

      const formData = new FormData();
      formData.append('file', renamedFile);

      this.baseAttachService.create(formData, fileName, this.systemMenuId, this.menuKey, this.pageParameter)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (event) => {
            console.log('profile pic res', event);

            if (event && event.type === HttpEventType.Response && event.body?.result) {
              this.imageId = event.body.result.id;
              this.baseService.showSuccessMessage('fileSaved');
              this.previousSelectedFile = file;
              resolve();
            }
          },
          error: (err) => {
            console.error(err);
            this.baseService.showErrorMessage('errorUploadingImage');
            reject(err);
          }
        });
    });
  }

  //#endregion

  getHeaderData(data): void {
    // debugger
    if (this.headerParams && this.headerParams.length > 0) {
      this.headerParamsData = Object.fromEntries(
        this.headerParams
          .map(paramsKey => {
            const matchedKey = Object.keys(data).find(dataKey =>
              dataKey === paramsKey ||        // exact match
              paramsKey.includes(dataKey) ||  // "pagemenukey".includes("menukey")
              dataKey.includes(paramsKey)     // "menukey".includes("pagemenukey")
            );
            return matchedKey ? [paramsKey, (data as any)[matchedKey]] : null;
          })
          .filter((entry): entry is [string, any] => entry !== null)
      );
    }
    if (this.headerKey) {
      const headerId = { [this.headerKey]: this.headerId }
      this.headerParamsData = { ...this.headerParamsData, ...headerId };
    }
  }

  //region destory subscribtion
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.gridService.save(null); // Reset saveRow to avoid memory leaks
    this.gridService.delete(null)
  }
  //end region
}
